"use strict";
var email = require('email-validation');

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var messages = {
  EMAIL_ERROR: gettext('Must be a valid email address'),
};

module.exports = function(schema, value) {
  if (!email.valid(value)) {
    return new Error(messages.EMAIL_ERROR);
  }
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/validators/email.js
 **/